import React from 'react';

import type { TableWidgetData } from '@/features/_shared/widget-registry';
import { WIDGET_TYPES, widgetRegistry } from '@/features/_shared/widget-registry';

import { MarketPreviewWidget } from './MarketPreviewWidget';

widgetRegistry.register<{ data: TableWidgetData }>(WIDGET_TYPES.TABLE, ({ data }) => (
  <MarketPreviewWidget data={data} />
));
